import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SupportRequestSearchFilter } from 'src/app/models/supportRequestSearchFilter';
import { SupportrequestService } from 'src/app/services/supportrequest.service';

@Component({
  selector: 'app-supportrequest-nofitication',
  templateUrl: './supportrequest-nofitication.component.html',
  styleUrls: ['./supportrequest-nofitication.component.css']
})
export class SupportrequestNofiticationComponent implements OnInit {

  displayedColumns: string[] = [''];
  sortColumns: string[] = ['notificationText'];
  sortDisabledColumn: string[] = ['Action'];

  supportRequestSearchFilter = new SupportRequestSearchFilter();
  data: any[] = [];
  itemPerPage: number = 10;
  endIndex: number = this.itemPerPage;
  currentIndex: number = 1;
  sortby: string = '';
  order: string = '';

  supportRequestCount: number;

  constructor(private supportRequestNotificationApi: SupportrequestService, private toastr: ToastrService) { }

  ngOnInit(): void {
    //this.getSupportRequestNotifications();

    this.supportRequestNotificationApi.supportRequestNotificationObservable.subscribe(data => {
      this.supportRequestNotificationApi.getSupportRequestNotification().subscribe(data => {
        this.data = data["result"];
        this.supportRequestCount = data["result"].length;
      }, err => {
        console.log(err);
        this.toastr.error(err["message"], "error");
      });
    })


  }

  getSupportRequestNotifications() {
    this.supportRequestNotificationApi.getSupportRequestNotification().subscribe(data => {
      this.data = data["result"];
      this.supportRequestCount = data["result"].length;
    }, err => {
      console.log(err);
      this.toastr.error(err["message"], "error");
    });
  }

}
